export const CARD_PATHS = {
  CARD_LIST: "/cards",
  PROFILE_UPDATE: "/profileupdate",
  CARD_FAQS: "/cards-faqs",
  CATEGORY_LOCK_KB_ARCTILE: "/category-lock-kb-article",
};
